export default __webpack_public_path__ + "static/media/photo-3.81adb56b.jpg";